import Vue from 'vue';
import permitsImportService from '@/api/permits-import-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';
import drivingPermitsImportService from '@/api/driving-permits-import-service';

const state = {
  drivingPermitsImportValidationErrors: {},
  drivingPermitsImportedFilesResponse: null,
};

const mutations = {
  SET_DRIVING_PERMITS_IMPORT_VALIDATION_ERRORS(state, permitValidationErrors) {
    state.drivingPermitsImportValidationErrors = permitValidationErrors;
  },

  SET_DRIVING_PERMITS_IMPORTED_FILE_RESPONSE(state, response) {
    state.drivingPermitsImportedFilesResponse = response;
  },

  CLEAR_DRIVING_PERMITS_IMPORT_VALIDATION_ERRORS(state, field) {
    Vue.delete(state.drivingPermitsImportValidationErrors, field);
  },
};

const actions = {
  uploadDrivingPermits({ commit }, payload) {
    return drivingPermitsImportService
      .upload(payload)
      .then((res) => {
        commit('SET_DRIVING_PERMITS_IMPORTED_FILE_RESPONSE', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('driving_permits_imported'));
        return res.data;
      })
      .catch((err) => {
        commit('SET_DRIVING_PERMITS_IMPORT_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
